<template>
  <div
    class="result"
    :class="{ 'result-h5': !isApp }"
    :style="{
      backgroundImage:
        'url(' +
        ((questionData && typeImageObj[questionData.userType].bg) || '') +
        ')'
    }"
  >
    <AppNavbar
      v-if="isApp"
      :placeholder="true"
      :options="options"
      :zIndex="20"
      :title="title"
    >
      <div slot="right" class="share-btn">
        <span class="share iconfont icon-share1" @click="bindShare"></span>
        <div class="share-tip" :class="{ 'share-tip-show': showShareTip }"
          >分享一下</div
        >
      </div>
    </AppNavbar>
    <div class="container" v-if="questionData">
      <!-- 用户信息 -->
      <div class="userinfo" v-if="questionData.userInfo">
        <img class="avatar" :src="questionData.userInfo.head_img" alt="" />
        <div class="nickname">Hi，{{ questionData.userInfo.nickname }}</div>
      </div>
      <div class="container-item user-content">
        <div
          class="paper"
          :style="{
            backgroundImage:
              'url(\'' +
              (isApp
                ? 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/a971c9056461b37e538cee4783cf6037.png'
                : 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/681a3faa3234c5707584d9a823e2a370.png') +
              '\')'
          }"
        >
          <!-- 类型 -->
          <img
            class="c-type"
            :src="questionData && typeImageObj[questionData.userType].typeImage"
            alt=""
          />
          <div class="tag-list">
            <img
              class="tag-item"
              :class="['tag-item-' + index]"
              v-for="(item, index) in questionData.fourQuadrants"
              :key="index"
              :src="tagObj[item]"
              alt=""
            />
          </div>
          <img
            class="person"
            :src="
              getPersonUrl(
                personList,
                questionData.userInfo.gender,
                questionData.userType
              )
            "
            alt=""
          />
        </div>
        <div class="bottom">
          <!-- bmi -->
          <BmiComponent
            class="bmi-component"
            :data="questionData.bmiInfo.bmi"
          ></BmiComponent>
          <div class="bmi-info">
            <div class="weight"
              >您的当前体重
              {{ questionData.bmiInfo.weight }}KG，距离您的目标体重还有<span
                class="loss-weight"
                >{{ questionData.bmiInfo.diff_weight }}KG</span
              ></div
            >
          </div>
          <!--  -->
          <div class="title">您减脂路上最大的拦路虎</div>
          <div class="quetions">
            <div
              class="q-item"
              v-for="(item, index) in questionData.wayDifficulty"
              :key="index"
            >
              <img
                class="q-image"
                src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/0d456a8002d168897832886f5219a45d.png"
                alt=""
              />
              <div class="q-text" v-html="item.content"></div>
            </div>
            <div class="sug" v-html="questionData.bmiInfo.content"></div>
          </div>
        </div>
      </div>
      <div class="container-item">
        <div class="title">专家营养师说</div>
        <img
          class="say-image"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/393006bd943b65017c30577c72180f89.png"
          alt=""
        />
        <div class="say-info">
          <div
            >Hi，{{
              questionData.userInfo && questionData.userInfo.nickname
            }}</div
          >
          <div v-html="questionData.starTheory"></div>
        </div>
      </div>
      <div class="container-item plan-image-content">
        <img
          class="plan-image"
          v-if="questionData.bmiInfo.bmi <= 24"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ec66176db5ac8771cef2a93d7728e318.png"
          alt=""
        />
        <img
          class="plan-image"
          v-else
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/804db98bc4d5be0486e2b66f8b64d768.png"
          alt=""
        />
        <div
          class="plan-btn"
          @click="jumpWorkWeixin"
          v-clickBuried
          data-click-buried="CLICK_XINRENWENJUAN_HUOKE"
        ></div>
      </div>
      <!-- 属于你的减脂TIPS -->
      <div class="container-item tip-content">
        <div class="title">属于你的减脂TIPS</div>
        <div class="tip-list">
          <div
            class="tip-item"
            v-for="(item, index) in questionData.tips"
            :key="index"
          >
            <div class="item-title">
              <MyFont :number="index + 1" :scale="1" class="my-font"></MyFont
              ><span class="i-title-text" v-html="item.title"></span>
            </div>
            <div class="item-text" v-html="item.content"></div>
          </div>
        </div>
      </div>
      <!-- 属于你的减脂计划 -->
      <div class="container-item plan-content" v-if="personType != 1">
        <div class="title">属于你的一站式减脂方案</div>
        <div class="course-content">
          <img
            class="course-image"
            v-if="personType == 0"
            @click="bindToVip"
            src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/44c948b3407d03d6ab334a2bc89bd6a2.png"
            alt=""
          />
          <img
            class="course-image"
            v-if="personType == 2"
            @click.stop="bindToCourse"
            :src="courseImage[questionData.recommendCourses.title]"
            alt=""
          />
        </div>
      </div>
      <!-- 咨询营养师 -->
      <div
        class="container-item coach-info"
        id="consult-2"
        v-if="personType == 2"
      >
        <img
          class="coach-image"
          @click="jumpWorkWeixin()"
          v-clickBuried
          data-click-buried="CLICK_XINRENWENJUAN_HUOKE"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/9eb73ba6e1e5ece2e744c5fda4cc156e.png"
          alt=""
        />
      </div>
      <!-- logo -->
      <div class="logo">
        <img
          class="logo-image"
          src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/9c9e5ae4abe13f7dbfa086685cadf699.png"
          alt=""
        />
      </div>
    </div>
    <!-- 分享组件 -->
    <van-overlay :show="showShare" @click="showShare = false" z-index="22">
      <ShareComponent
        v-if="showShare"
        class="share-container"
        @close="bindCloseShare"
        @link="bindClickLink"
        @image="bindClickImage"
        :copyUrl="qrcodeUrl"
        :linkShareIcon="linkShareIcon"
      />
    </van-overlay>
    <img
      v-if="!isApp"
      class="fixed-btn"
      src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/891944b555a858c5d5422f00c7618610.png"
      alt=""
      @click.stop="bindDowndload"
    />
  </div>
</template>
<script>
/* 
21天：https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/30c0ad5c0d23c3cafc53d57f924c3cdd.png
84天：https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/65a8ff6fabd641dd45988a66bf2f7434.png
咨询客服：https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/1a94ceef63259222cc858ab4b53514b6.png
*/
import AppNavbar from '@/components/app/nav-bar/index.vue'
import BmiComponent from './components/bmi.vue'
import ShareComponent from '@/components/app/share'
import MyFont from './components/my-font.vue'
export default {
  components: {
    AppNavbar,
    BmiComponent,
    ShareComponent,
    MyFont
  },
  data() {
    return {
      personType: 2,
      bmiData: 20,
      isApp: false,
      showShareTip: true,
      showShare: false,
      qrcodeUrl: '',
      title: '我的一站式减脂方案',
      linkShareIcon: [
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon2',
          name: '微信好友'
        },
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon3',
          name: '朋友圈'
        },
        {
          icon: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/app_camp_introduce_share_icon4',
          name: '复制链接'
        }
      ],
      options: {
        barBackgroundColor: 'rgba(0,0,0,0)',
        color: '#fff',
        fontSize: '18px'
      },
      typeImageObj: {
        持续精进型: {
          typeImage:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/4918b9c2ea1cf550a3bda65c04115ea0.png',
          bg: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/7139c78719804c3dbfa2237e2348ddd3.png'
        },
        盲目努力型: {
          typeImage:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/8f2e47f8506e303f84f300a8af2acc59.png',
          bg: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/e1963bfa7d74f9705317e4433e4fda19.png'
        },
        随性放飞型: {
          typeImage:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/3d6763892db10908b85ef22f5dbf92d9.png',
          bg: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d1ab3d4faec452dd26461f35fab4f1a6.png'
        },
        反复循环型: {
          typeImage:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/f868156e26484b4d37c9e1ff5f9de14f.png',
          bg: 'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d60c2701bbcd2ed58b33d432cdbefef1.png'
        }
      },
      tagList: ['饮食习惯', '饮食认知', '自律程度', '运动习惯'],
      tagObj: {
        随心所欲:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-tag-1-1',
        有待改善:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-tag-1-2',
        当代狠人:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-tag-1-3',
        一窍不通:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-tag-2-1',
        一知半解:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-tag-2-2',
        心知肚明:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-tag-2-3',
        为所欲为:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-tag-3-1',
        偶尔克制:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-tag-3-2',
        严于律己:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-tag-3-3',
        佛系躺平:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-tag-4-1',
        随心而动:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-tag-4-2',
        规律运动:
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-tag-4-3'
      },
      courseImage: {
        '放纵减肥法·21天女神蜕变营':
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/12bd5a776bde738f8e9cb8adf0b86ccd.png',
        '放纵减肥法*21天蜕变营':
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/c0398131d81fec8cbcf0220ab66685b8.png',
        '放纵减肥法·84天易瘦体质养成营':
          'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/d89d7e69dbf23644f59691a4e797d3a7.png'
      },
      questionData: null,
      personList: [
        {
          持续精进型:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/6b694ef86952258a767b5eb7a7658771.png',
          盲目努力型:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/8764ce84f3d11ad248e4c812e04b9bd9.png',
          随性放飞型:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/3a71147bb04319f940e46b19d42b598a.png',
          反复循环型:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/24e5e1bd39b45a84d0cfd40b3219759f.png'
        },
        {
          持续精进型:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/cb3a7da7278fd01bdaee21810ca09c3f.png',
          盲目努力型:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/9cfe1782c67ea486ba991e1f3f102710.png',
          随性放飞型:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/ed6fb84e855b2edf29713420132f4879.png',
          反复循环型:
            'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/0f4ac0a78c2c83d09a8190a33e15a9fd.png'
        }
      ],
      weixinData: {
        反复循环型: 'https://work.weixin.qq.com/ca/cawcde2c4e2cea4965',
        盲目努力型: 'https://work.weixin.qq.com/ca/cawcde6e5d5ec49fc9',
        随性放飞型: 'https://work.weixin.qq.com/ca/cawcde4d05c227e9c8',
        持续精进型: 'https://work.weixin.qq.com/ca/cawcdeafaf04385007'
      }
    }
  },
  computed: {
    nickname() {
      if (
        !this.questionData ||
        !this.questionData.userInfo ||
        this.questionData.userInfo.nickname == '独一无二的你'
      ) {
        return ''
      }
      return this.questionData.userInfo.nickname
    }
  },
  created() {
    this.isApp = this.$http._isApp()
    this.getResult()
  },
  mounted() {
    this.setQrcodeUrl()
    this.addScrollEvent()
    this.bindHideTip()
    if (!this.isApp) {
      document.title = 'ta的一站式减脂方案'
    }
    this.$buryPoint('BG_XRWJ_JG', {})
  },
  beforeDestroy() {
    this.removeScrollEvent()
  },
  methods: {
    bindDowndload() {
      location.href = 'https://member3.gymcity.com.cn/#/app-download'
    },
    //课程链接
    bindToCourse() {
      if (this.$http._isApp()) {
        if (this.questionData.recommendCourses) {
          this.$betterwe.onAppPageUrlRoute(
            '/wmOtherPage?fromType=11&url=' +
              this.questionData.recommendCourses.jump_url
          )
        }
      } else {
        this.bindDowndload()
      }
    },
    async jumpWorkWeixin() {
      switch (this.personType) {
        case 0:
          this.bindFatInstitute()
          break
        case 1:
          this.bindToVip()
          break
        case 2:
          //如果app版本高于指定版本才使用跳转企业微信客服，否则保持原来跳转规则
          let version = await this.$betterwe.getAppVersion()
          if (version >= 87) {
            this.$buryPoint('CLICK_XRWJ_JG_ZX1_NEW', {})
            let url = this.weixinData[this.questionData.userType]
            if (url) {
              location.href = url
            }
          } else {
            this.bindConsult(1)
          }
          break
      }
    },
    //咨询减脂研究所
    bindFatInstitute() {
      if (this.$http._isApp()) {
        this.$betterwe.onAppPageUrlRoute(
          '/miniProgram?userName=gh_0d804ee2c21b&path=pages/image-page/index?url=https%3A%2F%2Fcdnvue.gymcity.com.cn%2Fbetterwe_1.0%2Fvue%2F27b914a6ac3085e254d0272462d3daf1.jpg&title=添加卡所长'
        )
      } else {
        this.bindDowndload()
      }
    },
    //咨询
    bindConsult(index) {
      switch (index) {
        case 1:
          this.$buryPoint('CLICK_XRWJ_JG_ZX1', {})
          break
        case 2:
          this.$buryPoint('CLICK_XRWJ_JG_ZX2', {})
          break
      }
      if (this.$http._isApp()) {
        this.$http.sendUserAct(9)
        if (this.questionData.entranceBmi) {
          this.$betterwe.onAppPageUrlRoute(
            `/miniProgram?userName=gh_0d804ee2c21b&path=` +
              this.questionData.entranceBmi
          )
        }
      } else {
        this.bindDowndload()
      }
    },
    //咨询营养师涵涵
    bindConslutHanHan() {
      if (this.$http._isApp()) {
        this.$betterwe.onAppPageUrlRoute(
          `/miniProgram?userName=gh_0d804ee2c21b&path=pages/image-page/index?url=https%3A%2F%2Fcdnvue.gymcity.com.cn%2Fbetterwe_1.0%2Fvue%2Fd772d3c6a31c4c38685705012c3e6eec.png&type=10`
        )
      } else {
        this.bindDowndload()
      }
    },
    async bindToVip() {
      if (this.$http._isApp()) {
        let version = await this.$betterwe.getAppVersion()
        if (version >= 98) {
          this.$betterwe.vipHomePage()
        } else {
          this.$router.push('/betterwe/vip')
        }
      } else {
        this.bindDowndload()
      }
    },
    getResult() {
      let params = {
        rid: this.$route.query.rid || ''
      }
      this.$http
        .postBaseApp('member/AppCamp/getNewComerQue', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            res.data.fourQuadrants = this.tagToArray(
              res.data.fourQuadrants,
              this.tagList
            )
            this.personType =
              res.data.bmiInfo && this.getPersonType(res.data.bmiInfo.age)
            this.questionData = res.data
          } else {
            this.$toast(res.msg)
          }
        })
    },
    //获取人群类型
    getPersonType(age) {
      if (age === undefined) {
        return 2
      } else if (age <= 16) {
        return 0
      } else if (age > 16 && age <= 20) {
        return 1
      } else {
        return 2
      }
    },
    tagToArray(obj, list) {
      let res = []
      for (let i in obj) {
        console.log(i)
        let index = list.indexOf(obj[i].name)
        if (index >= 0) {
          res[index] = obj[i].tag
        }
      }
      return res
    },
    //隐藏分享按钮
    bindHideTip() {
      setTimeout(() => {
        this.showShareTip = false
      }, 3000)
    },
    addScrollEvent() {
      window.addEventListener('scroll', this.bindScroll)
    },
    removeScrollEvent() {
      window.removeEventListener('scroll', this.bindScroll)
    },
    bindScroll(e) {
      let maxHeight = 100
      var scroll = document.documentElement.scrollTop || document.body.scrollTop
      if (scroll < maxHeight) {
        scroll = scroll < 0 ? 0 : scroll
        this.options.barBackgroundColor =
          'rgba(255,255,255,' + (scroll / maxHeight).toFixed(2) + ')'
        this.options.color = 'rgba(255,255,255,1)'
      } else {
        this.options.barBackgroundColor = 'rgba(255,255,255,1)'
        this.options.color = 'rgba(0,0,0,0.8)'
      }
      if (this.elIsInView(document.getElementById('consult-1'))) {
        this.sendMua(1)
      }
      if (this.elIsInView(document.getElementById('consult-2'))) {
        this.sendMua(2)
      }
    },
    //判断元素是否在可视区域
    elIsInView(el) {
      if (!el) {
        return false
      }
      const viewPortHeight =
        window.innerHeight ||
        document.documentElement.clientHeight ||
        document.body.clientHeight
      const offsetTop = el.offsetTop
      const scrollTop = document.documentElement.scrollTop
      const top = offsetTop - scrollTop
      return top <= viewPortHeight
    },
    //发送曝光埋点
    sendMua(index) {
      if (!this['consult' + index]) {
        console.log('发送埋点' + index)
        this['consult' + index] = true
        switch (index) {
          case 1:
            this.$buryPoint('BG_XRWJ_JG_ZX1', {})
            break
          case 2:
            this.$buryPoint('BG_XRWJ_JG_ZX2', {})
            break
        }
      }
    },
    setQrcodeUrl() {
      this.qrcodeUrl =
        location.origin + location.pathname + '?rid=' + this.$route.query.rid
    },
    bindShare() {
      this.showShare = true
      this.$buryPoint('CLICK_XRWJ_JG_FX', {})
    },
    bindCloseShare() {
      this.showShare = false
    },
    bindClickImage(index) {},
    getPersonUrl(personList, gender, type) {
      gender = gender == '男' ? 1 : 2
      let index = gender - 1
      index = index >= 0 ? index : 0
      return personList[index][type]
    },
    bindClickLink(index) {
      switch (index) {
        case 0:
          this.shareFriend(0)
          break
        case 1:
          this.shareWechatCicle(0)
          break
        case 2:
          this.showShare = false
          break
      }
    },
    //分享到微信好友
    shareFriend(type) {
      let obj
      //分享链接
      if (type == 0) {
        console.log('链接分享到微信好友')
        obj = {
          shareType: 1, //分享的类型 1 微信好友 2 微信朋友圈
          contentType: 'url', //分享的数据类型  image 分享图片  url 分享H5链接
          // 分享的数据
          shareData: {
            data: this.qrcodeUrl, //分享的链接
            //分享的数据的格 式
            //contentType为image的情况下, type=base64  表示图片格式是base64   type=url  表示图片格式是链接
            type: 'url',
            desc: ' 快来看看给ta定制的一站式高效减脂方案吧！',
            title: (this.nickname || 'ta') + '是什么样的减脂选手？',
            thumbnail:
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-share-image' // 分享的缩略图的url
          }
        }
      } else if (type === 1) {
        console.log('图片分享到微信好友')
        obj = {
          shareType: 1, //分享的类型 1 微信好友 2 微信朋友圈
          contentType: 'image', //分享的数据类型  image 分享图片  url 分享H5链接
          // 分享的数据
          shareData: {
            data: this.imgUrl, //分享的链接
            //分享的数据的格 式
            //contentType为image的情况下, type=base64  表示图片格式是base64   type=url  表示图片格式是链接
            type: 'base64',
            desc: '快来看看给ta定制的一站式高效减脂方案吧！',
            title: (this.nickname || 'ta') + '是什么样的减脂选手？',
            thumbnail:
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-share-image' // 分享的缩略图的url
          }
        }
      }
      this.shareWechat(obj)
    },
    //分享到微信朋友圈
    shareWechatCicle(type) {
      let obj
      //分享链接
      if (type == 0) {
        console.log('链接分享到微信朋友圈')
        obj = {
          shareType: 2, //分享的类型 1 微信好友 2 微信朋友圈
          contentType: 'url', //分享的数据类型  image 分享图片  url 分享H5链接
          // 分享的数据
          shareData: {
            data: this.qrcodeUrl, //分享的链接
            //分享的数据的格 式
            //contentType为image的情况下, type=base64  表示图片格式是base64   type=url  表示图片格式是链接
            type: 'url',
            desc: '快来看看给ta定制的一站式高效减脂方案吧！',
            title: (this.nickname || 'ta') + '是什么样的减脂选手？',
            thumbnail:
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-share-image' // 分享的缩略图的url
          }
        }
      } else if (type === 1) {
        console.log('图片分享到微信朋友圈')
        obj = {
          shareType: 2, //分享的类型 1 微信好友 2 微信朋友圈
          contentType: 'image', //分享的数据类型  image 分享图片  url 分享H5链接
          // 分享的数据
          shareData: {
            data: this.imgUrl, //分享的链接
            //分享的数据的格 式
            //contentType为image的情况下, type=base64  表示图片格式是base64   type=url  表示图片格式是链接
            type: 'base64',
            desc: '快来看看给ta定制的一站式高效减脂方案吧！',
            title: (this.nickname || 'ta') + '是什么样的减脂选手？',
            thumbnail:
              'https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-share-image' // 分享的缩略图的url
          }
        }
      }
      this.shareWechat(obj)
    },
    //分享到微信
    shareWechat(obj) {
      if (this.$http._isApp()) {
        this.$betterwe.onAppShare(obj)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.result {
  min-height: 100vh;
  background-color: #f7f7f7;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center top;
  overflow: hidden;

  .share {
    font-size: 28px;
  }

  .container {
    width: 100%;
    padding: 10px 16px 0px;
    box-sizing: border-box;
  }

  .container-item {
    border-radius: 6px;
    padding: 14px 15px 20px;
    box-sizing: border-box;
    background-color: rgba(255, 255, 255, 0.88);
    box-shadow: 0px 2px 4px rgba(74, 61, 107, 0.09);
    margin-bottom: 16px;

    .title {
      position: relative;
      z-index: 0;
      display: inline-block;
      font-size: 22px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.9);
      line-height: 26px;
      margin-bottom: 22px;
    }

    .title::after {
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
      height: 10px;
      width: 100%;
      background: #8672ff;
      border-radius: 5px;
      opacity: 0.28;
      z-index: -1;
    }

    .shadow-title {
      display: inline-block;
      position: relative;
      font-size: 13px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #191919;
      line-height: 18px;
    }

    .shadow-title::after {
      content: '';
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      height: 9px;
      background: linear-gradient(
        180deg,
        rgba(155, 102, 255, 0) 0%,
        #6236ff 100%
      );
      opacity: 0.2;
    }
  }

  .say-image {
    width: 100%;
  }

  .say-info {
    font-size: 10px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: rgba(25, 25, 25, 0.5);
    line-height: 18px;
  }

  /* 用户信息 */
  .userinfo {
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    .avatar {
      width: 26px;
      height: 26px;
      border: 1px solid #fff;
      overflow: hidden;
      border-radius: 50%;
      margin-left: 5px;
      margin-right: 10px;
    }

    .nickname {
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      line-height: 20px;
    }
  }

  .user-content {
    padding: 0px;
    border-radius: 8px;
    overflow: hidden;
    background-color: transparent;
    border-top-right-radius: 50px;

    .paper {
      padding: 54px 20px 0px;
      box-sizing: border-box;
      width: 100%;
      height: 470px;
      position: relative;
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center bottom;
      background-image: url('https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/newcomer-questionnaire-paper?t=1');

      .c-type {
        width: 250px;
        height: 44px;
        object-fit: contain;
        margin-bottom: 56px;
      }

      .tag-list {
        position: relative;
        width: 100%;
        height: 230px;

        .tag-item {
          position: absolute;
          object-fit: contain;
          width: 53px;
          height: 56px;
        }

        .tag-item-0 {
          left: 0;
          top: 0;
        }

        .tag-item-1 {
          right: 0;
          top: 0;
        }

        .tag-item-2 {
          left: 0;
          bottom: 0;
        }

        .tag-item-3 {
          right: 0;
          bottom: 0;
        }
      }

      .person {
        position: absolute;
        top: 63%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 171px;
        height: 340px;
        object-fit: contain;
      }
    }

    .bottom {
      background-color: #fff;
      overflow: hidden;
      padding: 0px 20px 22px;

      .b-title {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 22px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #191919;
        line-height: 30px;
        margin-bottom: 15px;

        .dot {
          width: 30px;
          height: 30px;
          object-fit: contain;
        }
      }

      .bmi-component {
        margin-top: 10px;
        margin-bottom: 12px;
      }

      .bmi-info {
        font-size: 12px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #191919;
        line-height: 20px;
        border-radius: 10px;
        box-sizing: border-box;
        margin-bottom: 30px;

        .status {
          color: #626262;
          margin-bottom: 12px;
        }

        .weight {
          font-size: 12px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: rgba(0, 0, 0, 0.5);
          line-height: 20px;

          .loss-weight {
            color: #6c51f4;
          }
        }
      }
    }

    /*  */
    .quetions {
      .q-item {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.5);
        line-height: 22px;

        .q-image {
          display: inline-block;
          margin-right: 3px;
          width: 12px;
          height: 11px;
        }

        .q-text {
          display: inline-block;
        }
      }

      .sug {
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.5);
        line-height: 22px;
      }
    }

    /* 咨询 */
    .consult {
      position: relative;
      margin-bottom: 16px;

      .consult-image {
        object-fit: contain;
        width: 100%;
      }

      .btn {
        position: absolute;
        width: 100%;
        left: 50%;
        transform: translate(-50%, 0%);
        bottom: 16px;
        width: 262px;
        height: 36px;
      }
    }

    .coach-consult {
      width: 100%;
      height: 86px;
      background: #f5f5f5;
      border-radius: 10px;
      margin-bottom: 16px;
    }
  }

  /* 提示 */
  .tip-content {
    .title {
      margin-bottom: 29px;
    }

    .tip-list {
      .tip-item {
        margin-bottom: 24px;

        .item-title {
          text-indent: 34px;
          font-size: 16px;
          font-family: MiSans-Demibold, MiSans;
          font-weight: 600;
          color: rgba(0, 0, 0, 0.9);
          line-height: 22px;
          margin-bottom: 12px;
          position: relative;

          .my-font {
            position: absolute;
            left: 0;
            top: 0;
          }

          .i-title-text {
            line-height: 22px;
            display: inline;
          }
        }

        .item-text {
          font-size: 10px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: rgba(25, 25, 25, 0.5);
          line-height: 18px;
        }
      }

      .tip-item:last-child {
        margin-bottom: 0px;
      }
    }
  }

  .plan-image-content {
    position: relative;
    margin-bottom: 20px;
    padding: 0;
    background-color: transparent;
    border-radius: 10px;

    .plan-btn {
      position: absolute;
      width: 306px;
      height: 40px;
      left: 50%;
      bottom: 22px;
      transform: translate(-50%, 0%);
    }

    .plan-image {
      width: 100%;
    }
  }

  /* 计划 */
  .plan-content {
    .title {
      margin-bottom: 27px;
    }

    .course-content {
      position: relative;

      .course-image {
        width: 100%;
        object-fit: cover;
        border-radius: 16px;
      }

      .course-btn {
        position: absolute;
        width: 254px;
        height: 44px;
        left: 50%;
        bottom: 21px;
        transform: translate(-50%, 0%);
      }
    }
  }

  /* 咨询营养师 */
  .coach-info {
    padding: 0px 0px;
    margin-bottom: 20px;

    .coach-image {
      width: 100%;
    }
  }

  .share-container {
    position: absolute;
    width: 100%;
    bottom: 0;
    left: 0;
  }

  .logo {
    margin-bottom: 24px;

    .logo-image {
      height: 10px;
      margin: 0 auto;
    }
  }

  .share-btn {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    .share {
      width: 30px;
      height: 30px;
    }

    .share-tip {
      padding: 0px 7px;
      white-space: nowrap;
      height: 20px;
      font-size: 10px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      background-color: rgba(0, 0, 0, 0.5);
      line-height: 20px;
      z-index: 8;
      position: absolute;
      left: 0%;
      top: 120%;
      border-radius: 4px;
      transform: translate(-50%, 0%);
      opacity: 0;
      transition: opacity 0.5s linear;
    }

    .share-tip-show {
      opacity: 1;
    }

    .share-tip::after {
      content: '';
      position: absolute;
      top: -4px;
      right: 10px;
      width: 0;
      height: 0;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-top: 5px solid rgba(0, 0, 0, 0.5);
      transform: rotate(45deg);
    }
  }

  .fixed-btn {
    position: fixed;
    width: 323px;
    height: 82px;
    left: 50%;
    bottom: 20px;
    transform: translate(-50%, 0%);
    z-index: 999;
  }
}

.result-h5 {
  background-position: center -75px;
}
</style>
